<template>
  <div class="plan-container">
    <div class="search-hd">
      <el-form :inline="true" @submit.native.prevent>
        <el-form-item style="float: right; margin-right: 0" v-if="funcView.location_plan_export">
          <el-button class="table-set" style="vertical-align: top" @click.native="exportTable('locationPlanExport', formSearch)">
            <i class="icon icon-daochu"></i>
          </el-button>
        </el-form-item>
        <el-form-item style="float: right">
          <search-input v-model="formSearch.search" :placeholder="$t('dms_plan.ji_hua_ming_cheng')" @fetch="onPageChange({ page: 1 })"></search-input>
        </el-form-item>
        <el-form-item style="float: right">
          <switch-button :link="link"></switch-button>
        </el-form-item>
      </el-form>
    </div>
    <switch-container ref="container" @search="onPageChange({ page: 1 })" @clear="clearFilter()">
      <el-form :inline="true" label-position="top">
        <el-form-item :label="$t('dms_plan.xiang_mu_ming_cheng')">
          <el-input v-model="formSearch.locationName" clearable></el-input>
        </el-form-item>
        <el-form-item :label="$t('dms_plan.xmssgs')">
          <el-input v-model="formSearch.orgName" clearable></el-input>
        </el-form-item>
      </el-form>
    </switch-container>
    <div class="table-bd">
      <custom-table ref="table" index tableCode="location_plan" :data="planList" @filter="filterChange" @sort="sortChange" height="100%" @column="setColumn" :slots="['scheduleCondition', 'action']">
        <template v-slot:scheduleCondition="scope">
          <span v-if="scope.row.scheduleMethod == 2 && scope.row.scheduleCondition.split(',').length != 7">
            {{
              scope.row.scheduleCondition
                .replace('1', $t('dms_plan.xing_qi_yi'))
                .replace('2', $t('dms_plan.xing_qi_er'))
                .replace('3', $t('dms_plan.xing_qi_san'))
                .replace('4', $t('dms_plan.xing_qi_si'))
                .replace('5', $t('dms_plan.xing_qi_wu'))
                .replace('6', $t('dms_plan.xing_qi_liu'))
                .replace('7', $t('dms_plan.xing_qi_ri'))
            }}
          </span>
          <span v-if="scope.row.scheduleMethod == 2 && scope.row.scheduleCondition.split(',').length == 7">{{ $t('dms_plan.mei_ri_gong_zuo') }}</span>
          <span v-if="scope.row.scheduleMethod == 3 && scope.row.scheduleCondition != ''">{{ $t('dms_plan.mei_yue') }}{{ scope.row.scheduleCondition }}{{ $t('dms_plan.ri_xiu_xi') }}</span>
          <span v-if="scope.row.scheduleMethod == 3 && scope.row.scheduleCondition == ''">{{ $t('dms_plan.mei_ri_gong_zuo') }}</span>
        </template>
        <template v-slot:action="scope">
          <el-button type="text" size="mini" v-if="funcView.location_plan_edit" @click.native="editPlan(scope.row)">{{ $t('Common.com_edit') }}</el-button>
          <el-button type="text" size="mini" v-if="funcView.location_plan_delete" @click.native="delPlan(scope.row)">{{ $t('Common.com_delete') }}</el-button>
        </template>
      </custom-table>
    </div>
    <div class="table-page">
      <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
    </div>
    <location-plan-dialog v-if="dialogVisible" :model="dialogModel" @close="dialogVisible = false" @success="getTableList"></location-plan-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import locationPlanDialog from './location_plan_dialog';

export default {
  name: 'plan',
  components: { locationPlanDialog },
  computed: {
    userInfo() {
      return this.$store.state.userInfo;
    },
  },
  data() {
    return {
      formSearch: {
        search: '',
        pageSize: 50,
        pageNum: 1,
        locationName: '', // 项目名称
        orgName: '', // 项目所属公司
      },

      planList: [],
      totalRows: 0,

      dialogVisible: false,
      dialogModel: {},

      link: null,
    };
  },

  mounted() {
    this.resetFormSearch = JSON.stringify(this.formSearch);
    this.getFuncView(null, () => {
      setTimeout(() => {
        this.link = this.$refs.container;
      }, 500);
    });

    this.getTableList();
  },
  methods: {
    getTableList: function () {
      this.$getJSON(apis.locationSchedulePage, this.formSearch).then((res) => {
        this.planList = res.data.list || [];
        this.totalRows = res.data.total;
      });
    },
    editPlan(data) {
      const title = this.$t('dms_plan.bian_ji_ji_huao', [data.locationName]);
      this.dialogModel.type = 'edit';
      this.dialogModel.title = title;
      this.dialogModel.data = data;
      this.dialogVisible = true;
    },

    delPlan: function (row) {
      const title = this.$t('dms_plan.nqdyscgjhm');
      this.$showConfirm(title)
        .then(() => {
          this.$postJSON(`${apis.locationScheduleDelete}/${row.locationScheduleId}`).then(() => {
            this.$message({
              type: 'success',
              message: this.$t('Common.com_delete_success'),
            });
            this.getTableList();
          });
        })
        .catch(() => {});
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    // 清除
    clearFilter: function () {
      this.$refs.table.clearFilter();
      this.formSearch = JSON.parse(this.resetFormSearch);
      this.onPageChange({ page: 1 });
    },
  },
};
</script>

<style lang="scss">
@import '@/style/colors.scss';
.plan-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 0 16px;
  overflow: hidden;
}
</style>
